import React from 'react'
import {useDispatch} from 'react-redux'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

import {
  trackLoginClick,
  trackUserSignInClick
} from '@daedalus/core/src/auth/modules/actions'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import Button from '../../../../designSystem/Button'
import PersonBorderIcon from '../../../../../foundation/icons/PersonBorder'

import {
  AuthenticationFlows,
  ShowPasswordlessLoginPayload,
  SourceComponentType,
  TrackUserSignInClickSourceComponent
} from '@daedalus/core/src/auth/types/Auth'

interface Props {
  onSignIn: ({
    sourceComponent,
    flow
  }: {
    sourceComponent: ShowPasswordlessLoginPayload['sourceComponent']
    flow: ShowPasswordlessLoginPayload['flow']
  }) => void
}

const StyledButton = styled(Button)(
  () => css`
    white-space: nowrap;
  `
)

const MessageWrapper = styled('span')(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s300}px;
  `
)

const SignInButton = ({onSignIn}: Props) => {
  const dispatch = useDispatch()

  const component = SourceComponentType.Header

  const handleSingInClick = () => {
    dispatch(
      trackUserSignInClick(TrackUserSignInClickSourceComponent.UserWidgetSignIn)
    )
    dispatch(trackLoginClick(component))

    onSignIn({
      sourceComponent: component,
      flow: AuthenticationFlows.SignUp
    })
  }

  return (
    <StyledButton
      appearance="buttonLink"
      dataId="SignInButton"
      onClick={handleSingInClick}
    >
      <PersonBorderIcon />
      <MessageWrapper>
        <FormattedMessageWrapper
          id="userWidget.signIn"
          defaultMessage="Sign in"
        />
      </MessageWrapper>
    </StyledButton>
  )
}

export default SignInButton
